import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const MakeAppointmentIcon = props => {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M10 3.75a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zM6 13.25A3.75 3.75 0 002.25 17v1.188c0 .754.546 1.396 1.29 1.517 2.21.361 4.443.536 6.676.524.156-.001.25-.174.174-.31A6.968 6.968 0 019.5 16.5c0-.787.13-1.544.37-2.25a.213.213 0 00-.192-.28 7.247 7.247 0 01-1.928-.35l-.866-.284a1.752 1.752 0 00-.543-.086H6z"
        fill="#3D87BF"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 22a5.5 5.5 0 100-11 5.5 5.5 0 000 11zm0-1.5a4 4 0 100-8 4 4 0 000 8z"
        fill="#3D87BF"
      />
      <Path
        d="M16.5 14c.319 0 .577.258.577.577v1.346h1.346a.577.577 0 010 1.154h-1.346v1.346a.577.577 0 01-1.154 0v-1.346h-1.346a.577.577 0 010-1.154h1.346v-1.346c0-.319.258-.577.577-.577z"
        fill="#3D87BF"
      />
    </Svg>
  );
};

export default MakeAppointmentIcon;
